import { toast } from 'react-toastify';

import React, { useCallback, useMemo, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { findDocumentProtected, findDocument } from '../../processes/document';

import { getCode } from '../../utils/utils'
import * as NavigationUtils from '../../utils/navigation';

import PassCode from './PassCodePage';
import Header from '../../components/Header';
import Container from '../../components/Container';
import { usePatientDocumentContext } from '../../contexts/PatientDocument';

function PassCodeContainer() {
	const history = useHistory();
	const code = useMemo(() => getCode(), []);
	const { document, setInfo } = usePatientDocumentContext();

	const [loading, setLoading] = useState(true);
	const [initialLoading, setInitialLoading] = useState(true);

	const navigateToTermsPage = useCallback(() => {
		const url = `/terms?code=${code}`

		history.push(url);
	}, [history, code]);

	const fetchDocument = useCallback(async () => {
		const filter = {
			code: getCode()
		};

		if (!filter.code) {
			return;
		}

		setLoading(true);

		const { data, error } = await findDocument(filter);

		if (error) {
			if (error.code === 'INVALID_CODE' || error.data === 'NOT_FOUND') {
				return NavigationUtils.navigate(history, `/expired/${code || ''}`);
			} else {
				toast.error('Não foi possível buscar as informações do formulário.');
			}
		} else {
			setInfo({
				document: data,
				code
			});

			if (!data.request_pass_code) {
				navigateToTermsPage();
			}
		}

		setLoading(false);
	}, [code, setInfo, history, navigateToTermsPage]);

	const fetchData = useCallback(async () => {
		await fetchDocument();
		setInitialLoading(false);
	}, [fetchDocument]);

	useEffect(() => {
		fetchData();
	}, [fetchData]);

	const handleFindDocumentProtected = useCallback(async passCode => {
		const filter = {
			code,
			document_number: passCode
		};

		setLoading(true);

		const { data, error } = await findDocumentProtected(filter);

		setLoading(false);

		if (error) {
			toast.error('Documento inválido!');
		} else {
			setInfo(value => ({
				...value,
				document: {
					...data,
					request_pass_code: false,
					pass_code: passCode
				},
			}));

			navigateToTermsPage();
		}
	}, [code, setInfo, navigateToTermsPage]);

	const submitPassCode = useCallback((cpf) => {
		handleFindDocumentProtected(cpf);
	}, [handleFindDocumentProtected]);

    return (
		<Container>
			<Header/>

			<PassCode
				loading={loading}
				document={document}
				initialLoading={initialLoading}
				onSubmitPassCode={submitPassCode}
			/>
		</Container>
	);
}

export default PassCodeContainer;
